
export const FETCH_RESERV_REQUEST = 'FETCH_RESERV_REQUEST';
export const FETCH_RESERV_SUCCESS = 'FETCH_RESERV_SUCCESS';
export const FETCH_RESERV_FAILURE = 'FETCH_RESERV_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';